import CreateConferenceMenu from '@/components/menu/CreateConferenceMenu';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuTrigger } from '@/components/ui/dropdown-menu.tsx';
import { LoadingSpinner } from '@/components/ui/spinner.tsx';
import { cn } from '@/lib/utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlineVideoCameraAdd } from 'react-icons/ai';

export default function CreateConferenceButton({ className }: { className?: string }) {
  const [processing, setProcessing] = useState(false);
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            disabled={processing}
            className={cn(
              'h-12 leading-[3rem] rounded-3xl bg-gradient-to-r from-blue-500 to-indigo-700 hover:opacity-90',
              className
            )}
          >
            {processing ? (
              <>
                <LoadingSpinner size={6} className="mr-2 text-white" />
                {t('button.processing')}
              </>
            ) : (
              <>
                <AiOutlineVideoCameraAdd className="w-5 h-5 mr-2" />
                {t('button.newMeeting')}
              </>
            )}
          </Button>
        </DropdownMenuTrigger>
        <CreateConferenceMenu onProcessing={setProcessing} />
      </DropdownMenu>
    </div>
  );
}
